import type { CustomFieldInputType, FieldColumn } from "@/api/db/connection";

export const DocumentFieldLabels = {
	institutional: "Dado institucional",
	fieldColumns: {
		name: "Nome da paciente",
		cpf: "CPF",
		rg: "RG",
		birth_date: "Data de nascimento",
		mother_name: "Nome da mãe",
		occupation: "Profissão",
		marital_status: "Estado civil",
		address: "Endereço",
		phone: "Telefone",
		email: "E-mail",
		age: "Idade",
		current_date: "Data atual",
	} satisfies Record<Exclude<FieldColumn, "custom">, string>,

	inputTypes: {
		text: {
			label: "Texto",
			placeholder: "Digite o valor",
			invalid: "Valor inválido",
		},
		date: {
			label: "Data",
			placeholder: "DD/MM/AAAA",
			invalid: "Data inválida",
		},
		time: {
			label: "Horário",
			placeholder: "HH:MM",
			invalid: "Horário inválido",
		},
		currency: {
			label: "Dinheiro",
			placeholder: "R$ 0,00",
			invalid: "Valor inválido",
		},
		number: { label: "Número", placeholder: "0", invalid: "Número inválido" },
		percentage: {
			label: "Percentual",
			placeholder: "0%",
			invalid: "Percentual inválido",
		},
		cpf: {
			label: "CPF",
			placeholder: "000.000.000-00",
			invalid: "CPF inválido",
		},
		phone: {
			label: "Telefone",
			placeholder: "(00) 00000-0000",
			invalid: "Telefone inválido",
		},
	} satisfies Record<CustomFieldInputType, { label: string; placeholder: string; invalid: string }>,

	fieldCreated: "Campo criado.",
	fieldRenamed: "Campo renomeado.",
	fieldUpdated: "Campo atualizado.",
	fieldRemoved: "Campo removido.",
	cancel: "Cancelar",
	save: "Salvar",

	profile: {
		title: "Dados institucionais",
		description: "Dados da clínica presentes nos documentos.",
		value: "Valor",
		edit(label: string) {
			return `Editar ${label}`;
		},
		saved: "Dado institucional atualizado.",
		error: "Não foi possível atualizar o dado institucional.",
	},

	policies: {
		title: "Políticas dos termos",
		description: "Versões das políticas presentes nos termos.",
		value: "Novo valor",
		newVersion: "Nova versão aplicada aos próximos modelos e atualizações.",
		version(version: number) {
			return `Versão ${version}`;
		},
		edit(label: string) {
			return `Editar ${label}`;
		},
		saved: "Nova versão da política criada.",
		error: "Não foi possível criar a versão da política.",
	},

	error(code: string | undefined) {
		if (code === "FIELD_REFERENCED") {
			return "Este campo está em uso em documentos e não pode ser removido.";
		}

		if (code === "NOT_FOUND") {
			return "Campo não encontrado.";
		}

		return "Não foi possível salvar o campo.";
	},
};
